import { Card, EmptyState } from "./commonComponents";
import MrclText from '../../marcel/MrclText';
import { useTranslation } from 'react-i18next';

const EmptyDataCard = () => {
    const {t} = useTranslation();
    
    return (
        <Card>
        <EmptyState>
            <MrclText
            style={{
                margin: 0,
                fontSize: 14,
                color: "#64748b",
                fontWeight: 500,
            }}
            >
            {t('common.no_data')}
            </MrclText>
        </EmptyState>
        </Card>
    );
};

export default EmptyDataCard;